import { configureStore } from '@reduxjs/toolkit';
import loginReducer from '../components/Login/loginSlice';
import registerReducer from '../components/Register/registerSlice';
import chatReducer from '../components/ChatApp/chatSlice';
import featuresReducer from '../features/featuresSlice';

export const store = configureStore({
  reducer: {
    login: loginReducer,
    register: registerReducer,
    chat: chatReducer,
    features: featuresReducer,
  },
});